import type { PlanCoordinateConflict, BoundingBox } from '../types/plan';

/**
 * Extract global coordinates from conflict object.
 * CN-0012: Now using global coordinates directly.
 */
export const getConflictWorld = (conflict: PlanCoordinateConflict): { rowWorld: number; colWorld: number } | null => {
  const rowWorld = conflict.rowWorld ?? conflict.row_world;
  const colWorld = conflict.colWorld ?? conflict.col_world;
  if (rowWorld === undefined || colWorld === undefined) return null;
  return { rowWorld, colWorld };
};

/**
 * Convert conflict global coordinates to grid position.
 * CN-0012: Returns global coordinates directly (no transformation needed).
 * @deprecated Use global coordinates directly from cells.row/col
 */
export const conflictToGrid = (
  conflict: PlanCoordinateConflict,
  boundingBox: BoundingBox
): { row: number; col: number } | null => {
  const coords = getConflictWorld(conflict);
  if (!coords) return null;
  // In CN-0012 system, global coordinates are used directly
  return { row: coords.rowWorld, col: coords.colWorld };
};

/**
 * Check if a coordinate is within the valid bounding box range.
 * CN-0012: Simplified check using minRow/maxRow/minCol/maxCol.
 */
export const isInBounds = (
  row: number,
  col: number,
  boundingBox: BoundingBox
): boolean => {
  return (
    row >= boundingBox.minRow &&
    row <= boundingBox.maxRow &&
    col >= boundingBox.minCol &&
    col <= boundingBox.maxCol
  );
};

